import { HttpBackend, HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, catchError, map, of } from 'rxjs';

import { environment as env, environment } from '../../../environments/environment';
import { AuthRequest } from '../models';
import { BaseService } from './base.service';

@Injectable()
export class AuthService extends BaseService {
  private readonly SPINNER_NAME: string = 'x-frontend-spinner-loader';
  private httpNoInterceptor: HttpClient;
  private _triggerWebVersion$ = new Subject<any>();
  constructor(
    private readonly http: HttpClient,
    private httpBackend: HttpBackend
  ) {
    super();
    this.envService = env.services.auth;
    this.headers = new HttpHeaders(this.envService.headers);
    this.httpNoInterceptor = new HttpClient(httpBackend);
  }

  get triggerWebVersion$() {
    return this._triggerWebVersion$.asObservable();
  }

  triggerWebVersion(value: any) {
    this._triggerWebVersion$.next(value);
  }

  public logIn(payload: AuthRequest): Observable<any> {
    const body = new HttpParams()
      .set('username', payload.username)
      .set('password', payload.password)
      .set('grant_type', payload.grant_type);

    this.headers = this.headers.set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<any>(this.getUrl(), body, { headers: this.headers });
  }

  public refreshToken(refreshToken: string, request: HttpRequest<any> = null): Observable<any> {
    const body = new HttpParams().set('refresh_token', refreshToken).set('grant_type', 'refresh_token');

    this.headers = this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    if (request?.headers.has(this.SPINNER_NAME)) {
      this.headers = this.headers.set(this.SPINNER_NAME, request.headers.get(this.SPINNER_NAME));
    }

    return this.http.post<any>(this.getUrl(), body, { headers: this.headers });
  }

  public bypassAuthenToken<T>(): Observable<T> {
    const body = new HttpParams().set('grant_type', 'client_credentials');

    return this.http.post<T>(this.getUrl(), body, { headers: this.headers });
  }

  public getWebVersion() {
    return this.httpNoInterceptor.get('/assets/VERSION', { responseType: 'text' }).pipe(
      map(val => val?.trim()),
      map(version => {
        const currentVersion = environment.version.split('-')[0];
        const shouldReload = version && currentVersion && currentVersion !== version;
        if (shouldReload) {
          console.log(`Update Web Version!!: from ${currentVersion} to ${version}`);
        }

        return shouldReload;
      }),
      catchError(() => of(false))
    );
  }
}
